export const Locales = {
    english: 'en-us',
    bengali: 'bn-bd',
    urdu: "ur-pk",
    hindi: "hi-in",
    pashto: "ps-af",
}
